import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireVerified = false }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="vh-100 d-flex align-items-center justify-content-center bg-dark">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-light">Loading...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Check if email verification is required
    if (requireVerified && user.verified === false) {
        return <Navigate to="/verify" replace />;
    }

    return children;
};

export default ProtectedRoute;

